import * as React from "react";
const SvgAdd = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 4.167v11.666M4.167 10h11.666" /></svg>;
export default SvgAdd;